<template>
  <section>
    <div v-if="item.rollingStockId">
      <section v-if="!rollingStocks.length">
        <div class="col-12 mt-5">
          <small class="ml-2 px-2 bg-danger text-white">{{ $t('reservation.details.transport.no-times') }}</small>
        </div>
      </section>
      <section v-else>
        <div class="col-12 mt-5">
          <div>
            {{ service.service.title_NL }}<br />
            {{
              $t('reservation.details.transport.train-tickets', {
                type: service.supplierType
              })
            }}
          </div>
        </div>
        <div class="col-12 mt-3 pl-3" v-if="stockItems.length > 1">
          <div class="row">
            <div class="col">
              <core-basic-drop-down
                :items="stockItems"
                :selection.sync="selectedStock"
                customLabel="Trein"
                :simpleValue="false"
              ></core-basic-drop-down>
            </div>
          </div>
        </div>
        <div class="col-12 mt-2">
          <div class="pl-2 row d-flex align-items-center">
            <div class="col-5">
              <small
                :class="{
                  'font-weight-bold': isOutbound,
                  'font-italic': !isOutbound
                }"
                class="p-0 ml-0"
                >{{ $t('reservation.details.transport.outbound') }}</small
              >
              <small
                :class="{
                  'font-weight-bold': !isOutbound,
                  'font-italic': isOutbound
                }"
                class="p-0 ml-4"
                >{{ $t('reservation.details.transport.inbound') }}</small
              >
            </div>
            <div class="col-7">
              <core-lever
                class="ml-3 pt-1 float-right"
                :label="$t('reservation.details.transport.show-times-to-customer')"
                labelClass="ml-2"
              ></core-lever>
            </div>
          </div>
        </div>
        <div class="col-12">
          <reservation-details-transport-time
            v-if="times.length"
            :key="timeCounter"
            :times="times"
            :departureDate="service.dateFrom"
            :arrivalDate="service.dateUntil"
            :originStation.sync="service.stationOrigin"
            :destinationStation.sync="service.stationDestination"
          ></reservation-details-transport-time>
        </div>
        <div
          class="mt-4 col-lg-12 d-flex align-items-center justify-content-between"
        >
          <small class="pl-2">{{
            $t('reservation.details.transport.transport')
          }}</small>
          <core-lever
            class="ml-3 pt-1"
            :label="$t('reservation.details.transport.show-data-to-customer')"
            labelClass="ml-2"
            :value="item.showData"
            @input="(isChecked) => item.showData = isChecked"
          ></core-lever>
          <core-lever
            class="ml-3 pt-1"
            :label="$t('reservation.details.transport.show-prices-to-customer')"
            labelClass="ml-2"
            :value="item.showPrices"
            @input="(isChecked) => item.showPrices = isChecked"
          ></core-lever>
        </div>
        <div class="col-12" v-if="prices">
          <reservation-details-transport-type
            :key="stockCounter"
            :rollingStockId="getSelectedRollingStockId()"
            :reservationLineId="getReservationLineId()"
            :prices="getTransportTypePrices"
            :selectedTypes="item.rollingStockCoupes"
            @amountChanged="updateTravelersTransportType"
          >
          </reservation-details-transport-type>
        </div>
        <div class="col-12 mt-2">
          <div class="d-flex row align-items-between">
            <div class="col">
              <span class="total-price-description">{{
                $t('reservation.details.transport.total-price-description')
              }}</span>
            </div>
            <div class="col-3 d-flex row align-items-center">
              <core-money-input
                class="total-price-amount"
                :key="getSubTotal + ''"
                readonly
                :amount="getSubTotal"
              ></core-money-input>
            </div>
          </div>
        </div>
        <div
          class="mt-4 col-lg-12 d-flex align-items-center justify-content-between"
        >
          <small class="pl-2">{{
            $t('reservation.details.transport.travelers')
          }}</small>
        </div>
        <div class="mt-1 col-12">
          <reservation-details-transport-travelers
            :key="travelersKey"
            :rollingStockId="
              service.supplierType === 'Free sale' || !service.service.stock
                ? item.service.id
                : getSelectedRollingStockId()
            "
            :isFreeSale="service.supplierType === 'Free sale' || !service.service.stock"
            :reservationLineId="getReservationLineId()"
            :serviceId="service.serviceId"
            :travelers.sync="passengers"
            :placements="placements"
            @seatsChosen="seatsChosen"
          >
          </reservation-details-transport-travelers>
        </div>
      </section>
    </div>
    <div v-else>
      <div class="col-12 mt-5">
        <div>
          {{ service.service.title_NL }}<br />
          {{
            $t('reservation.details.transport.train-tickets', {
              type: service.supplierType
            })
          }}
        </div>
      </div>
      <div class="col-12 mt-2">
        <div class="pl-2 row d-flex align-items-center">
          <div class="col-5">
            <small
              :class="{
                'font-weight-bold': item.outbound,
                'font-italic': !item.outbound
              }"
              class="p-0 ml-0"
              >{{ $t('reservation.details.transport.outbound') }}</small
            >
            <small
              :class="{
                'font-weight-bold': !item.outbound,
                'font-italic': item.outbound
              }"
              class="p-0 ml-4"
              >{{ $t('reservation.details.transport.inbound') }}</small
            >
          </div>
          <div class="col-7">
            <core-lever
              class="ml-3 pt-1 float-right"
              :label="$t('reservation.details.transport.show-times-to-customer')"
              labelClass="ml-2"
            ></core-lever>
          </div>
        </div>
      </div>

      <div v-if="item.statusCode === 'TODO'">
        <div class="mt-4 col-lg-12 d-flex align-items-center justify-content-between">
          <small class="pl-2">{{ $t('reservation.details.transport.notes') }}</small>
        </div>
        <div class="col-12 mt-2">
          <textarea class="form-control" rows="3" v-model="item.notes"></textarea>
        </div>
      </div>
      <div class="col-12">
        <reservation-details-free-sale-transport-time
          v-if="times.length"
          :key="timeCounter"
          :times="times"
          :departureDate="service.dateFrom"
          :arrivalDate="service.dateUntil"
          :originStation.sync="service.stationOrigin"
          :destinationStation.sync="service.stationDestination"
        ></reservation-details-free-sale-transport-time>
      </div>
      <div
        class="mt-4 col-lg-12 d-flex align-items-center justify-content-between"
      >
        <small class="pl-2">{{
          $t('reservation.details.transport.transport')
        }}</small>
        <core-lever
          class="ml-3 pt-1"
          :label="$t('reservation.details.transport.show-data-to-customer')"
          labelClass="ml-2"
          :value="item.showData"
          @input="(isChecked) => item.showData = isChecked"
        ></core-lever>
        <core-lever
          class="ml-3 pt-1"
          :label="$t('reservation.details.transport.show-prices-to-customer')"
          labelClass="ml-2"
          :value="item.showPrices"
          @input="(isChecked) => item.showPrices = isChecked"
        ></core-lever>
      </div>
      <div class="col-12">
        <reservation-details-free-sale-transport-type
          :key="stockCounter"
          :service="item.service"
          :arrivalDate="service.dateFrom"
          :departureDate="service.dateUntil"
          :selectedTypes="item.reservationLines"
          :outbound="item.outbound"
          :selectedClass="selectedClass"
          :selectedRoomsAmount="selectedRoomsAmount"
          :dataIsFilling="dataIsFilling"
          :travelers="travelers"
          @occupancyLoaded="setOccupancyLoaded"
          @freeSaleAmountChanged="updateFreeSaleType"
          :prices.sync="getTransportTypePrices"
        >
        </reservation-details-free-sale-transport-type>
        <div class="col-12 mt-2">
          <div class="d-flex row align-items-between">
            <div class="col">
              <span class="total-price-description">{{
                $t('reservation.details.transport.total-price-description')
              }}</span>
            </div>
            <div class="col-3 d-flex row align-items-center">
              <core-money-input
                class="total-price-amount"
                :key="getSubTotal"
                readonly
                :amount="getSubTotal"
              ></core-money-input>
            </div>
          </div>
        </div>
      </div>
    </div>
    <!-- Free sale notes -->
    <div v-if="item.statusCode !== 'TODO'">
      <div class="mt-4 col-lg-12 d-flex align-items-center justify-content-between">
        <small class="pl-2">{{ $t('reservation.details.transport.notes') }}</small>
      </div>
      <div class="col-12 mt-2">
        <textarea class="form-control" rows="3" v-model="item.notes"></textarea>
      </div>
    </div>
    <div class="col-12 mt-2" v-if="item.statusCode === 'DONE'">
      {{ $t('reservation.booking-date') }}:<br/>
      <core-calendar
        :key="item.bookingDate"
        :date.sync="item.bookingDate"
      ></core-calendar>
    </div>
    <div v-if="item.statusCode === 'PENDING'">
      <div class="mt-4 col-lg-12 d-flex align-items-center justify-content-between">
        <small class="pl-2">{{ $t('reservation.booking-mail-sent-date') }}</small>
      </div>
      <div class="col-12 mt-2">
        <input class="form-control" type="text" readonly :value="item.bookingMailSentDate" />
      </div>
    </div>
    <div v-if="item.statusCode === 'DECLINED'">
      <div class="mt-4 col-lg-12 d-flex align-items-center justify-content-between">
        <small class="pl-2">{{ $t('reservation.booking-mail-declined-date') }}</small>
      </div>
      <div class="col-12 mt-2">
        <input class="form-control" type="text" readonly :value="item.bookingMailAnswerDate" />
      </div>
    </div>
    <div v-if="((item.actionDate && item.actionDate !== 'NaN-NaN-NaN') || actionDateCalculated) && item.statusCode === 'TODO'" class="mt-4 col-lg-12 d-flex align-items-center justify-content-between">
      <small v-if="(item.actionDate && item.actionDate !== 'NaN-NaN-NaN')" class="green-text pl-2">Active action date: <strong>{{ formattedActionDate }}</strong> <button class="btn-custom-send white-text" @click="clearActionDate(item)">&#x2715;</button></small>
      <small v-if="(!item.actionDate || item.actionDate === 'NaN-NaN-NaN') && actionDateCalculated" class="red-text pl-2">Inactive action date: <strong>{{ actionDateCalculated }}</strong> <button class="btn-custom-send white-text" @click="activateActionDate(item)">&#10003;</button></small>
    </div>
    <div class="col-12 mt-2"><label><input type="checkbox" v-model="item.automaticallyBooked"> {{ $t('reservation.automatically-booked') }}</label></div>
    <div class="col-12" v-if="isTicketBooking()">
      <div class="d-flex row align-items-center">
          <div class="col-3">{{ $t('reservation.departure-time') }}:</div>
          <div class="col-3"><input class="form-control" type="text" v-model="item.departureTime" :readonly="(item.statusCode === 'DONE' || item.statusCode === 'DECLINED') ? true : false"></div>
          <div class="col-3">{{ $t('reservation.arrival-time') }}:</div>
          <div class="col-3"><input class="form-control" type="text" v-model="item.arrivalTime" :readonly="(item.statusCode === 'DONE' || item.statusCode === 'DECLINED') ? true : false"></div>
      </div>
    </div>
    <div class="mt-4 col-lg-12 d-flex align-items-center justify-content-between">
      <small class="pl-2">{{ $t('reservation.details.accommodation.day-to-day-text') }}</small>
    </div>
    <div class="col-12 mt-2">
      <core-editor
        ref="newNoteEditor"
        class="col-sm-12 mb-2"
        v-model="item.dayToDayText"
      ></core-editor>
    </div>
    <reservation-details-media-box :reservationLineId="item.id" />
    <div class="col-12 mt-2" v-if="prompt">
      <small class="pl-2">{{ $t('reservation.details.accommodation.prompt') }}:</small>
      <textarea class="form-control" rows="10" v-model="prompt"></textarea>
    </div>
  </section>
</template>

<script>
import { rlProps } from '@/mixins/reservationLineProperties'
export default {
  mixins: [rlProps],
  methods: {
    setOccupancyLoaded () {
      this.$emit('occupancyLoaded', true)
    },
    sendBooking () {
      this.$emit('send-booking', this.item.id)
    },
    isTicketBooking () {
      if (this.item.service.relativeBookingLink && this.item.service.relativeBookingLink.indexOf('/pass') === -1) {
        return true
      }
      return false
    }
  }
}
</script>

<style scoped>
div >>> .btn {
  text-transform: capitalize;
  font-style: italic;
}
div >>> .btn:hover,
div >>> .btn {
  text-decoration: none;
}
div >>> .btn.active {
  border: 0;
  font-weight: bold;
  font-family: 'Open Sans Bold';
  font-style: normal;
  box-shadow: none !important;
}
div >>> .btn.btn-link {
  color: #767676 !important;
}
</style>



// WEBPACK FOOTER //
// src/components/reservation/details/Transport.vue